import { IGetGedArquivoDataUseCase } from "../../../presentation/useCases/read/get_ged_arquivo_data_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * GetGedArquivoDataUseCase
 */

export class GetGedArquivoDataUseCase implements IGetGedArquivoDataUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getGedArquivoData(
    idArquivoModulo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const blob  = await this.repository.getGedArquivoData(idArquivoModulo);
    if (!blob) throw new Error('Falha ao buscar dados da imagem!');

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(nomeArquivo));
    document.body.appendChild(link);
    link.click(); 
    
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
